module.exports = __webpack_public_path__ + "img/img_29.d9c2e2f2.svg";